import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import UpcomingHeader from "./UpcomingHeader";
import UpcomingDetailsTab from "./UpcomingDetailsTab";

function UpcomingWrap() {

    return (
        <>
            <div className="package-details-wrapper pt-110">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-9">
                            <div className="tour-package-details">
                                <UpcomingHeader />
                                <UpcomingDetailsTab />
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="package-sidebar">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpcomingWrap;
